export default "__VITE_ASSET__5578534c__"